import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, Pencil } from 'lucide-react';
import DashboardLayout from '../../components/DashboardLayout';
import { expensesAPI } from '../../services/api';
import { format } from 'date-fns';
import { resolveUploadUrl } from '../../utils/uploadUrl';

export default function ExpenseDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [expense, setExpense] = useState(null);

  useEffect(() => {
    if (!id) return;
    expensesAPI.getById(id).then((res) => setExpense(res.data)).catch(() => navigate('/dashboard/expenses'));
  }, [id, navigate]);

  if (!expense) return <DashboardLayout><div className="p-8 text-ga-text-muted">Loading...</div></DashboardLayout>;

  return (
    <DashboardLayout>
      <div className="max-w-2xl space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-4 min-w-0">
            <Link
              to="/dashboard/expenses"
              aria-label="Back to expenses"
              className="shrink-0 p-2 rounded-lg text-ga-text-primary hover:bg-ga-bg-surface-subtle"
            >
              <ArrowLeft className="h-5 w-5" />
            </Link>
            <h1 className="text-2xl font-bold text-ga-text-primary truncate">Expense details</h1>
          </div>
          <Link
            to={`/dashboard/expenses/${id}/edit`}
            className="ga-btn-ghost inline-flex items-center gap-2 px-4 py-2 rounded-lg"
          >
            <Pencil className="h-4 w-4" />
            Edit
          </Link>
        </div>
        <div className="ga-card rounded-ga-lg shadow-ga-soft border border-ga-border-subtle p-6 space-y-3">
          <p><span className="text-ga-text-muted">Date:</span> {expense.expense_date ? format(new Date(expense.expense_date), 'dd MMM yyyy') : '—'}</p>
          <p><span className="text-ga-text-muted">Category:</span> {expense.category_name || '—'}</p>
          {(expense.equipment_name || expense.equipment_id) && (
            <p><span className="text-ga-text-muted">Equipment:</span> {expense.equipment_name || 'Equipment linked'}</p>
          )}
          {expense.description ? (
            <p><span className="text-ga-text-muted">Description:</span> {expense.description}</p>
          ) : null}
          <p><span className="text-ga-text-muted">Amount:</span> <strong>₹{Number(expense.amount).toLocaleString()}</strong></p>
          <p><span className="text-ga-text-muted">Payment mode:</span> {expense.payment_mode}</p>
          {expense.paid_to ? (
            <p><span className="text-ga-text-muted">Paid to:</span> {expense.paid_to}</p>
          ) : null}
          {expense.invoice_url && (
            <div>
              <p className="text-ga-text-muted mb-2">Receipt:</p>
              <a
                href={resolveUploadUrl(expense.invoice_url)}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
              >
                <img
                  src={resolveUploadUrl(expense.invoice_url)}
                  alt="Expense receipt"
                  className="max-h-48 rounded-lg border border-ga-border-subtle object-contain"
                />
              </a>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
